import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { PeremriFormaFjales, PeremrillojiParametri, PeremriTrajtatEShkurtraTeBashkuaraKolonat } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriVetorVetaINjejesTrajtatEShkurtraTeBashkuaraConstants } from '@core/globals/peremri/peremri-vetor/peremri-vetor-veta-I-njejes-constants/peremri-vetor-veta-I-njejes-trajtat-e-shkurtra-te-bashkuara-constants';
import { PeremriTrajtatEShkurtraTeBashkuaraForCreationDTO } from '@core/interfaces/dto/peremri-trajtat-e-shkurtra-te-bashkuara-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriVetorTrajtatEShkurtraTeBashkuaraFormulaService } from './peremri-vetor-trajtat-eshkurtra-te-bashkuara-formula.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriVetorTrajtatEBashkuaraService {

  constructor(
    private fb: UntypedFormBuilder,
    private peremriVetorTrajtatEBashkuaraService: PeremriVetorTrajtatEShkurtraTeBashkuaraFormulaService,
  ) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriVetorTrajtatEShkurtraTeBashkuara') as UntypedFormArray;
    this.generateTrajtatEShkurtraForms(formArray, manual);
    peremriBaza.peremriTrajtatEShkurtraTeBashkuara?.forEach((item) => {
      let index = formArray.controls.findIndex(
        (c) =>
          c.get('kolonaId')?.value == item.kolonaId &&
          c.get('pershkrimi')?.value == '' &&
          c.get('formaFjalesId')?.value == item.formaFjalesId
      );
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
      } else {
        this.addNewLakimi(form, item.kolonaId, item.pershkrimi, item.formaFjalesId);
      }
    });
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generateTrajtatEShkurtraForms(form.get('peremriBaza.peremriVetorTrajtatEShkurtraTeBashkuara') as UntypedFormArray, manual);
  }

  generateTrajtatEShkurtraTeBashkuaraFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriVetorTrajtatEShkurtraTeBashkuara') as UntypedFormArray;
    this.peremriVetorTrajtatEBashkuaraService.generateFormula(peremriLlojiParametri, formArray);
  }

  generateTrajtatEShkurtraForms(formArray: UntypedFormArray, manual: boolean) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    for (const ptshbk of PeremriConstants.PeremriTrajtatEShkurtraTeBashkuaraKolonat) {
      const peremriForm = this.fb.group({
        kolonaId: ptshbk.id,
        pershkrimi: '',
        formaFjalesId: null
      });

      formArray.push(peremriForm);
    }

    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, kolona: PeremriTrajtatEShkurtraTeBashkuaraKolonat, pershkrimi?: string, formaFjales?: PeremriFormaFjales) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriVetorTrajtatEShkurtraTeBashkuara');
    const peremriForm = this.fb.group({
      kolonaId: kolona,
      pershkrimi: pershkrimi,
      formaFjalesId: formaFjales
    });
    formArray.push(peremriForm);
  }


  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriTrajtatEShkurtraTeBashkuaraForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriVetorTrajtatEShkurtraTeBashkuara') as UntypedFormArray;


    formArray.value.forEach((p: any) => {
      creationDTO.push({
        kolonaId: p.kolonaId,
        pershkrimi: p.pershkrimi,
        formaFjalesId: p.formaFjalesId,
        radhitja: p.radhitja
      })
    })

    return creationDTO;
  }
}
